import config from "@/config";
import Router from 'vue-router';

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
        path: '/card',
        component: () =>
            import ('@/views/card'),
        name: 'Card',
    }, {
        path: '*',
        component: () =>
            import ('@/views/index'),
        name: 'Index',
    }]
})

const router = createRouter()

//设置标题
//document.title = config.title

export default router


// WEBPACK FOOTER //
// ./src/router/index.js